import { render, staticRenderFns } from "./ModalServiceContainer.vue?vue&type=template&id=c58d3060&scoped=true&"
import script from "./ModalServiceContainer.vue?vue&type=script&lang=ts&"
export * from "./ModalServiceContainer.vue?vue&type=script&lang=ts&"
import style0 from "./ModalServiceContainer.vue?vue&type=style&index=0&id=c58d3060&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c58d3060",
  null
  
)

export default component.exports